import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useState, useContext } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import "./style.css";
import moment from "moment";
import config, { config2 } from "../../../config";
import $ from "jquery";
import { millionComma, removeMillionComma } from "../../../utils";
import { formatItemStatus, uomConversion, uomConversionUnit } from "../util";
import TruncatedTextWithTooltip from "../../../components/TruncatedTextWithTooltip";
import PayDtlCard from "../../../components/PayDtlCard";
import { BiCreditCard, BiInfoCircle } from "react-icons/bi";
import Tippy from "@tippyjs/react";
import { Modal } from "react-bootstrap";
import ItemViews from "../../Master/Item/view";
import { ConfigContext } from "../../../App";

function ChallanReturnView(props) {
  const itemLevelNarration = useContext(ConfigContext)?.itemLevelNarration;
  const { id } = useParams();
  const location = useLocation();
  let filter = location.state?.currentFilter;
  let currentFilterState = location.state?.showFilter;
  let page = location.state?.currentPageNo;
  const [sale, setSale] = useState(location.state?.sale || []);
  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const handleItemView = (data) => {
    setSelectedItemId(data);
    setShowItemModal(true);
  };
  const handleItemModalClose = () => {
    setShowItemModal(false);
    setSelectedItemId(null);
  };

  // console.log("salesale", sale)
  const [user, setUser] = useState({});
  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const [godown, setGodown] = useState([]);
  useEffect(
    function () {
      setGodown(() => props.godown);
    },
    [props],
  );

  useEffect(
    function () {
      if (sale.length == 0) {
        $.post(
          `${config.apiUrl}/challanRtn/listChallanRtn`,
          JSON.stringify({ challan_rtn_id: id, list_type: 3 }),
          function (res) {
            setSale(res?.data?.list?.[0] || []);
          },
        );
      }
    },
    [sale],
  );
  const challanDtl = {
    item_id: "",
    item_name: "",
    qty: "",
    rate: "",
    amount: "",
    disc: "",
    disc_amt: "",
    godown_id: "",
    avail_qty: null,
    alt_conv: "",
    base_uom: "",
    alt_uom: "",
    uom: "",
    alt_qty: "",
    alt_price: "",
    alt_rate: "",
    base_rate: "",
    narration: "",
  };
  const payDtl = [
    { mode: "Cash UGX", conv: 1, conv_amt: "", amt: "" },
    { mode: "USD", conv: 1, conv_amt: "", amt: "" },
    { mode: "Momo Pay", conv: 1, conv_amt: "", amt: "" },
    { mode: "Airtel Money", conv: 1, conv_amt: "", amt: "" },
  ];
  const initialState = {
    challan_no: "",
    challan_id: "",
    challan_date: "",
    cust_id: "",
    cust_name: "",
    total_amt: "",
    reason: "",
    branch_id: "",
    vehicle_no: "",
    trans_date: moment().format("YYYY-MM-DD"),
    payment_mode_id: 1,
    challan_dtl: [challanDtl],
    pay_dtl: payDtl,
  };

  const [formInputs, setFormInputs] = useState(initialState);
  // useEffect(() => {
  //   if (sale && Array.isArray(sale.challan_dtl)) {
  //     let prod = [...sale?.challan_dtl];

  //     for (let i = 0; i < prod?.length; i++) {
  //       let element = {};
  //       element = prod[i];
  //       if (element.uom == element.alt_uom) {
  //         let newProdDtl = {
  //           ...element,
  //           qty: element.alt_qty,
  //           alt_qty: element.qty,
  //           // amount: element.qty * element.rate,
  //           amount: element.qty * element.alt_price,
  //         };
  //         prod[i] = newProdDtl;
  //       } else {
  //         let newProdDtl = {
  //           ...element,
  //           amount: element.qty * element.rate,
  //         };
  //         prod[i] = newProdDtl;
  //       }
  //     }

  //     setFormInputs((prevState) => {
  //       let newState = {
  //         ...prevState,
  //         challan_dtl: prod,
  //         pay_dtl: sale?.pay_dtl ? JSON.parse(sale.pay_dtl) : prevState.pay_dtl,
  //       };

  //       return newState;
  //     });
  //   }
  // }, [sale]);

  useEffect(() => {
    if (!sale?.challan_rtn_id) return;

    const fetchChallanDtl = async () => {
      try {
        const res = await $.post(
          `${config2.apiUrl}/challanRtn/listChallanRtnDtl`,
          JSON.stringify({
            challan_rtn_id: sale?.challan_rtn_id,
            // is_active: 1,
            list_type: 3,
            paginate: 0,
          }),
        );
        console.log("res?.datares?.data", res?.data);
        let prod = res?.data?.list?.map((element) => {
          if (element.uom === element.base_uom) {
            return {
              ...element,
              amount: element.qty * element.rate,
            };
          } else {
            return {
              ...element,

              qty: element.alt_qty,
              alt_qty: element.qty,
              amount: element.qty * element.alt_price,
            };
          }
        });

        setFormInputs((prevState) => ({
          ...prevState,
          challan_dtl: prod,
          pay_dtl: sale?.pay_dtl ? JSON.parse(sale.pay_dtl) : prevState.pay_dtl,
        }));
      } catch (error) {
        console.error("Error fetching challan details:", error);
      }
    };

    fetchChallanDtl();
  }, [sale?.challan_rtn_id]);

  const [showPayDtl, setShowPayDtl] = useState(false);
  const handlePayDtl = () => {
    setShowPayDtl((prevState) => !prevState);
  };
  function getPaymentMode() {
    const paymentModes = formInputs.pay_dtl.filter(
      (pay) => pay.amt !== "" && pay.amt !== undefined && pay.amt > 0,
    );

    if (paymentModes.length === 0) {
      return "Cash UGX";
    } else if (paymentModes.length === 1) {
      return paymentModes[0].mode;
    } else {
      return "Multiple";
    }
  }
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2 position-relative pb-8">
          <Header />
          <Breadcrumb path={["Challan Return", "View Challan Return"]} />

          <main className="bg-white rounded-2" id="saleReturnAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to="/challanRtn"
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
                state={{
                  backToCurrent: page,
                  appliedFilter: filter,
                  filterDisplay: currentFilterState,
                  pageSize: location.state?.pageSize || 10,
                }}
              >
                Go Back to List
              </Link>
              <form className="row gx-4 gy-2" autoComplete="off">
                <div className="row mb-1">
                  <div className="col-md-3">
                    <label htmlFor="cust_id">Challan No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cust_id"
                      value={sale?.challan_no || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="cust_id">Challan Return No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cust_id"
                      value={sale?.challan_rtn_no || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="cust_id">Customer Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="cust_id"
                      value={sale?.mst_cust?.customer_name || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="trans_date">Challan Return Date</label>
                    <input
                      type="text"
                      className="form-control"
                      id="trans_date"
                      value={moment(sale.trans_date).format("DD-MM-YYYY")}
                      disabled
                    />
                  </div>
                  {/* <div className="col-md">
                                        <label htmlFor="is_active">Status</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="is_active"
                                            value={formatStatus(sale)}
                                            disabled
                                        />
                                    </div> */}
                </div>
                <div className="row mb-1">
                  <div className="col-md-3">
                    <label htmlFor="payment_mode_id">Payment Mode</label>
                    <input
                      type="text"
                      className="form-control"
                      id="payment_mode_id"
                      value={
                        config?.paymentMode?.find(
                          (p) => p?.value == sale?.payment_mode_id,
                        )?.label || "N/A"
                      }
                      // value={sale?.config?.paymentMode?.payment_mode_id || 'N/A'}
                      disabled
                    />
                  </div>
                  {user.role_id != 3 && user.role_id != 4 && (
                    <div className="col-md-3">
                      <label htmlFor="branch_name">Branch Name</label>

                      <input
                        type="text"
                        className="form-control"
                        id="branch_name"
                        value={sale?.mst_branch?.branch_name}
                        disabled
                      />
                    </div>
                  )}
                  <div className="col-md-3">
                    <label htmlFor="vehicle_no">Vehicle No</label>

                    <input
                      type="text"
                      className="form-control"
                      id="vehicle_no"
                      value={sale?.vehicle_no}
                      disabled
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="reason">Reason</label>
                    <textarea
                      type="text"
                      className="form-control"
                      id="reason"
                      value={sale.reason}
                      disabled
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <table
                      className="table mt-4 rounded"
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Item Name</th>
                          <th>UOM</th>
                          <th> Qty</th>

                          <th>Recd. Date</th>
                          <th>Rate</th>
                          <th>Godown</th>
                          <th>Amount</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formInputs.challan_dtl &&
                          formInputs.challan_dtl.map((v, i) => (
                            <tr key={i}>
                              <td style={{ width: "365px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "1px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={v?.mst_item?.item_name}
                                    disabled
                                  />
                                  {formInputs.challan_dtl[i]?.item_id ? (
                                    <Tippy content="View Item">
                                      <div>
                                        {" "}
                                        <span
                                          className=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleItemView(v)}
                                        >
                                          <BiInfoCircle size={20} />
                                        </span>
                                      </div>
                                    </Tippy>
                                  ) : null}
                                </div>
                                {itemLevelNarration == 1 ? (
                                  <textarea
                                    type="text"
                                    className="form-control mt-1"
                                    name={"narration"}
                                    value={v?.narration}
                                    disabled
                                    maxLength={100}
                                  />
                                ) : null}
                              </td>
                              <td>
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <select
                                    id=""
                                    name="uom"
                                    value={v?.uom}
                                    disabled
                                    className="form-select"
                                    style={{ width: "100px" }}
                                  >
                                    {[v.base_uom, v.alt_uom].map((ele, ind) => (
                                      <option value={ele}>{ele}</option>
                                    ))}
                                  </select>
                                )}
                              </td>
                              <td style={{ width: "100px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={parseFloat(v.qty || 0).toFixed(2)}
                                  disabled
                                />
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span
                                    className="text-right"
                                    style={{
                                      wordBreak: "break-all",
                                      fontSize: "10px",
                                    }}
                                  >
                                    <TruncatedTextWithTooltip
                                      text={uomConversionUnit(v)}
                                    />
                                  </span>
                                )}
                              </td>

                              <td>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={
                                    moment(v.updatedAt).isValid()
                                      ? moment(v.updatedAt).format("DD-MM-YYYY")
                                      : "-"
                                  }
                                  disabled
                                />
                              </td>
                              <td style={{ width: "130px" }}>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  // value={millionComma(v?.rate || 0)}
                                  value={
                                    v?.uom == v?.alt_uom
                                      ? millionComma(v?.alt_price)
                                      : millionComma(v?.rate)
                                  }
                                  disabled
                                />
                                {/* {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span style={{ whiteSpace: "nowrap" }}>
                                    {`Per (`}
                                    <TruncatedTextWithTooltip text={v?.base_uom} />
                                    {`)`}
                                  </span>
                                )} */}
                                {v?.alt_uom != null &&
                                  v?.alt_uom !== "" &&
                                  (v?.uom == v?.alt_uom ? (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`( ${v?.rate} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`(${v?.alt_price} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ))}
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    godown?.find(
                                      (x) => x?.godown_id === v?.godown_id,
                                    )?.godown_name || "-"
                                  }
                                  disabled
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={
                                    v?.uom === v?.base_uom
                                      ? millionComma(
                                        parseFloat(v?.qty || 0) *
                                        parseFloat(v?.rate || 0),
                                      )
                                      : millionComma(
                                        parseFloat(v?.qty || 0) *
                                        parseFloat(v?.alt_price || 0),
                                      )
                                  }
                                  // value={millionComma(v.amount)}
                                  disabled
                                />
                              </td>
                              <td style={{ width: "90px" }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={formatItemStatus(v)}
                                  disabled
                                />
                              </td>
                              {/* <td>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={formatItemStatus(v)}
                                                        disabled
                                                    />
                                                </td> */}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </form>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 position-absolute bottom-0 start-0 end-0">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col-md-3">
                      <label htmlFor="totalRef">Gross Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="totalRef"
                        value={millionComma(sale?.total_amount || 0)}
                        disabled
                      />
                    </div>

                    {/* Discount Temporary Discount Disable */}
                    {/*<div className="col">
                                            <label htmlFor="discRef">Discount Total</label>
                                            <input
                                                type="text"
                                                className="form-control text-end"
                                                id="discRef"
                                                value={parseFloat(sale?.discount_amount || 0).toFixed(2)}
                                                disabled
                                            />
                                        </div>
                                        <div className="col">
                                            <label htmlFor="finalRef">Final Total</label>
                                            <input
                                                type="text"
                                                className="form-control text-end"
                                                id="finalRef"
                                                value={parseFloat(parseFloat(sale?.total_amount || 0) - parseFloat(sale?.discount_amount || 0)).toFixed(2)}
                                                disabled
                                            />
                                        </div>*/}
                    <div className="col d-flex mt-auto justify-content-end gap-2">
                      <div
                        style={{
                          border: "1px solid gray",
                          height: "32px",
                          minWidth: "200px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <b className="me-2"> {getPaymentMode()} </b> :{" "}
                        {millionComma(sale?.total_amount || 0)}
                      </div>
                      <BiCreditCard
                        size={32}
                        className="text-primary mt-1"
                        role="button"
                        onClick={handlePayDtl}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      {showPayDtl && (
        <PayDtlCard
          cardMode="view"
          showPayDtl={showPayDtl}
          handlePayDtl={handlePayDtl}
          formInputs={formInputs}
          setFormInputs={setFormInputs}
          // grossTotal={removeMillionComma(sale?.total_amount)}
          grossTotal={sale?.total_amount}
        />
      )}
      <Modal
        show={showItemModal}
        onHide={handleItemModalClose}
        keyboard={false}
        backdrop="static"
        size="lg"
      >
        <ItemViews id={selectedItemId} hide={handleItemModalClose} />
      </Modal>
    </>
  );
}

export default ChallanReturnView;
